import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { TaskService } from '@autocaller_v2/services/TaskService';
import ItemForm from '@autocaller_v2/components/tasks-create-edit-form.vue';
import FileUpload from '@autocaller_v2/components/tasks/file-upload/form';

class TaskModalService extends ModalService {
  constructor() {
    super(TaskService);
  }

  remove(item) {
    return this.$removeDeepItem(item, {
      content: i18n.t('autocaller_v2.webhook.modal.remove.content', {
        type: `<strong>${item.id}</strong>`
      })
    });
  }

  edit(item, use_skills) {
    return this.$open({
      title: i18n.t('autocaller_v2.task.modal.edit'),
      width: this.size.default_plus,
      loading: true,
      render: (h) => {
        return h(ItemForm, {
          props: {
            is_edit: true,
            id: item.id,
            item: item,
            campaign_id: item.campaign_id,
            number_disabled: true,
            priority_disabled: true,
            attempts_disabled: true,
            start_disabled: true,
            use_skills: use_skills
          },

          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        });
      }
    });
  }

  import(campaign_id) {
    return this.$open({
      title: i18n.t('autocaller_v2.task.modal.import'),
      width: this.size.default,

      render: (h) =>
        h(FileUpload, {
          props: {
            campaign_id
          },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }

  create(campaign_id, skills) {
    return this.$open({
      title: i18n.t('autocaller_v2.task.modal.create'),
      width: this.size.default_plus,

      render: (h) =>
        h(ItemForm, {
          props: {
            campaign_id,
            use_skills: skills
          },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new TaskModalService();
export { instance as TaskModalService };
